import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import MasterCardAlertConstants from '../constants/MasterCardAlertConstants';
import AppConstants, { CHANGE_EVENT } from '../constants/AppConstants';

let navigationReference = '';
let manageAlertsAccountID = '';

class MasterCardAlertStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }

  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }

  setNavigation(ref) {
    navigationReference = ref;
  }
  getNavigation() {
    return navigationReference;
  }
  getManageAlertsAccountID() {
    return manageAlertsAccountID;
  }
  resetStore() {
    navigationReference = '';
    manageAlertsAccountID = '';
  }
  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action;
    switch (actionType) {
      case MasterCardAlertConstants.NAVIGATION_REFERENCE:
        navigationReference = actionData.ref;
        this.emitChange();
        break;

      case MasterCardAlertConstants.SET_MANAGE_ALERTS_ACCOUNT_ID:
        manageAlertsAccountID = actionData.accountID;
        this.emitChange();
        break;
      case AppConstants.LOGOUT_USER:
        this.resetStore();
        this.emitChange();
        break;
      default: {
        break;
      }
    }
  }
}

export default new MasterCardAlertStore();
